import React from "react";
import { IconProps } from "./IconProps";

const Alert: React.FC<IconProps> = ({
  size = 22,
  color = "#F7F9F9",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M9.99963 7.56953V10.9029M9.99963 14.2362H10.008M8.84573 3.31263L1.99166 15.1515C1.61149 15.8081 1.4214 16.1365 1.4495 16.4059C1.474 16.641 1.59714 16.8546 1.78828 16.9935C2.00741 17.1529 2.38679 17.1529 3.14556 17.1529H16.8537C17.6125 17.1529 17.9919 17.1529 18.211 16.9935C18.4021 16.8546 18.5253 16.641 18.5498 16.4059C18.5779 16.1365 18.3878 15.8081 18.0076 15.1515L11.1535 3.31263C10.7747 2.65833 10.5853 2.33118 10.3382 2.2213C10.1227 2.12545 9.8766 2.12545 9.66105 2.2213C9.41394 2.33118 9.22454 2.65833 8.84573 3.31263Z"
        stroke="#F7F9F9"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Alert;
